import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["menu"]

  connect() {
    this.closeHandler = (e) => {
      if (!this.element.contains(e.target)) {
        this.close()
      }
    }
    document.addEventListener("click", this.closeHandler)
  }

  disconnect() {
    document.removeEventListener("click", this.closeHandler)
  }

  toggle() {
    if (this.hasMenuTarget) {
      const isOpen = this.menuTarget.style.display !== "none"
      this.menuTarget.style.display = isOpen ? "none" : "block"
    }
  }

  close() {
    if (this.hasMenuTarget) {
      this.menuTarget.style.display = "none"
    }
  }
}
